
import { makeStyles } from '@mui/styles';
import { m } from 'framer-motion';
export const useStyles = makeStyles((theme) => {
    return {
        blockCropper: {
            height: '395px',
            width: '100%',
            position: 'relative',
            '@media(max-width: 550px)': {
                height: '348px',
            },

        },
        controller: {
            textAlign: 'left',
            height: '57px',
            width: '100%',
            display: 'flex',
            marginTop: '10px',
            gap: '10px',
            alignItems: 'center',
            position: 'relative',
            background: '#fff',
            '& .MuiButton-outlined.Mui-disabled': {
                background: '#eceff1',
                border: 0,
                opacity: '0.5',
            },


        },
        uploadIcon: {
            width: '50px',
            height: '50px',
            textAlign: 'center',
            lineHeight: '68px',
            borderRadius: '9px',
            border: '2px solid #EEF0F2',


        },
        btnActiopn: {
            '& .MuiButton-iconSizeSmall': {
                margin: '0',
            },
            minWidth: 43,
        },
        dragHereIcon: {
            fontSize: 50,
            color: theme.palette.grey[600],
        },
        dragHereText: {
            paddingTop: theme.spacing(2),
            fontFamily: 'Vazir',
            fontSize: '13px'
        },
        dragHereTextDesc: {
            fontWeight: '400',
            color: '#667585'
        },
        dragHereTextBold: {
            color: '#0369CD',
            fontWeight: '700'

        },
        showFormat: {
            direction: 'rtl',
            fontSize: 13,
            marginTop: '4px',
            fontWeight: '400',
            color: '#667585',
        },
        uploadBlock: {
            '& img': {
                width: '100%',
                height: '100%',
                position: 'absolute',
                top: '0',
                right: '0',
                objectFit: 'cover',
                borderRadius: ' 10px',
                border: '4px solid #FFF',
                transitionDuration: '0.5ms',


            },
            '&:hover': {
                '& button ,  div': {
                    opacity: '1',
                    transitionDuration: '0.5ms',

                },
                '& img': {
                    filter: 'grayscale(1) blur(2px)',
                    transitionDuration: '0.5ms',
                },

            }

        },
        btnActiopnModify: {
            display: 'flex',
            flexDirection: 'column',

        },
        removeButton: {
            opacity: '0',
            transitionDuration: '0.5ms',
            background: '#FFF',
            border: '1px solid #ccc',
            '& .MuiButton-label': {
                gap: '5px',
            },
            '&:hover': {
                transitionDuration: '0.5ms',
                background: '#303d8f',
                color: '#fff',
                border: '1px solid #303d8f',

                '& svg': {
                    '& path': {
                        fill: ' #fff',
                        transitionDuration: '0.5ms',

                    }
                }

            },

        },
        changeButton: {
            opacity: '0',
            transitionDuration: '0.5ms',
            background: '#FFF',
            marginBottom: '15px!important',
            border: '1px solid #ccc',
            height: '42px',
            padding: ' 8px 22px',
            fontSize: '12px',
            display: 'flex',
            zIndex: 100,
            alignItems: 'center',
            gap: '5px',
            fontWeight: '500',
            borderRadius: '8px',
            '& .MuiButton-label': {
                gap: '5px',
            },
            '&:hover': {
                transitionDuration: '0.5ms',
                background: '#303d8f',
                color: '#fff',
                border: '1px solid #303d8f',

                '& svg': {
                    '& path': {
                        fill: ' #fff',
                        transitionDuration: '0.5ms',

                    }
                }

            }


        },
        actions: {
            '& h4': {
                fontSize: '13px',
                color: '#546e7a',
                margin: 0,
                color: ' #546e7a',
                fontWeight: 'normal',
                marginBlockEnd: '16px',
            },
        },
        actionButtons: {
            display: 'flex',
            gap: '10px',
            justifyContent: 'space-between',
            margin: '12px 0',
            cursor: 'pointer',
            padding: '23px 32px',
            width: 250,
            boxSizing: 'border-box',
            height: 200,
            textAlign: 'center',
            alignItems: 'center',
            justifyContent: 'center',
            flexdirection: 'column',
            border: ' 2px solid #E2E5E9',
            borderRadius: 10,
            position: 'relative',
            transitionDuration: '0.5ms',

            '&:hover': {
                border: `2px solid #2B3990`,
                transitionDuration: '0.5ms',
            },

            '&.fullWidth': {
                width: 400,
                '@media(max-width: 550px)': {
                    width: '100%',
                },
            }

        }

    };
});
